export type FlagStatus = 'New' | 'Approved' | 'Rejected';

export interface AnswerOption {
  text?: string;
  isCorrect?: boolean;
  [key: string]: unknown;
}

export interface FlaggedQuestionSnapshot {
  text: string;
  imagePath?: string | null;
  reason?: string | null;
  type: string;
  options?: AnswerOption[];
}

export interface QuestionFlagItem {
  id: string;
  studentId: string;
  studentName: string;
  lessonId: number;
  lessonName: string;
  questionNumber: number;
  status: FlagStatus | string;
  reason?: string | null;
  studentComment?: string | null;
  createdAt: string;
  question?: FlaggedQuestionSnapshot | null;
}

export interface PaginatedQuestionFlags {
  flags: QuestionFlagItem[];
  totalCount: number;
  currentPage: number;
  pageSize: number;
  totalPages: number;
}

export interface UpdateFlagStatusRequest {
  status: FlagStatus;
  reason?: string | null;
}

export function getFlagStatusColor(status: string): string {
  switch (status) {
    case 'New':
      return 'text-blue-600 bg-blue-50';
    case 'Approved':
      return 'text-green-600 bg-green-50';
    case 'Rejected':
      return 'text-red-600 bg-red-50';
    default:
      return 'text-gray-600 bg-gray-50';
  }
}

export function getFlagStatusLabel(status: string): string {
  return status || 'Unknown';
}
